import React from 'react'
import styled from 'styled-components'
import { widgetPadding, webBtnSize, mobileBtnSize } from './constants'
const CenterButton = ({ onClick, dashTheme, isMobile }: { onClick: () => void }, props): React.ReactElement => {
    return (
        <StyledCenterMapButton onClick={onClick} dashTheme={dashTheme} className={isMobile ? 'isMobile' : null}>
            <i className="far fa-location" />
        </StyledCenterMapButton>
    )
}

const StyledCenterMapButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${webBtnSize}px;
    height: ${webBtnSize}px;
    outline: none;
    border: 0;
    padding: 0;
    transition: 0.05s linear;
    position: absolute;
    z-index: 700;
    bottom: 92px;
    right: ${widgetPadding}px;
    box-shadow: 0 0px 3px rgba(0, 0, 0, 0.65);
    border-radius: 2px;
    background-color: ${props => (props.dashTheme == 'light' ? 'white' : '#212a3e')};
    color: #37a3ef;
    &:active {
        box-shadow: inset 0px 0px 2px rgba(68, 68, 68, 0.6);
        transform: scale(0.95);
        transition: 0.05s linear;
        font-size: 11px;
    }
    &:hover {
        background-color: ${props => (props.dashTheme == 'light' ? ' #f4f4f4' : '#3b4b6d')};
    }
    i {
        font-size: 14px;
    }
    &.isMobile {
        width: ${mobileBtnSize}px;
        height: ${mobileBtnSize}px;
        bottom: 112px;
        i {
            font-size: 16px;
        }
    }
`

export default CenterButton
